import { useMemo } from "react";
import { QUERIES } from "../../../../graphql";
import { UserPrivacySettings } from "../../../../graphql/models";
import { useSnackbarQuery } from "../../../../hooks";

export default function useUserPrivacyHistory(userId: string) {
  const { loading, error, data } = useSnackbarQuery(
    QUERIES.USER_PRIVACY_REGISTRY,
    {
      variables: {
        userId,
      },
    }
  );

  const userPrivacyHistory = useMemo(() => {
    return data?.userPrivacyRegistry as UserPrivacySettings[];
  }, [data]);

  return { loading, error, userPrivacyHistory };
}
